// extracted by mini-css-extract-plugin
export default {"background":"modal_background__tagHt","modal":"modal_modal__4TXNT"};